import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type {
  RotationCalendar,
  RotationCalendarRotation,
  RotationCalendarSemester,
} from "@shared/models/rotation-calendar"
import type CourseCalendarEditor from "cc-frontend/services/course-calendar-editor"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import { includes } from "lodash-es"
import styles from "./course-slot.module.css"

// Can't have no TagName because sortable-item needs it
export default class PlanbookWeeklyOrderCourseSlot extends Component {
  readonly styles = styles

  // args
  rotation!: RotationCalendarRotation
  semester!: RotationCalendarSemester
  rotationCalendar!: RotationCalendar
  course!: Course

  @service("ember-store") store!: EmberStore
  @service dialog!: Dialog
  @service courseCalendarEditor!: CourseCalendarEditor

  @computed("course.attributes.calendar.datesOff.[]")
  get isOn() {
    let id = `${this.semester.id}:${this.rotation.id}`
    return !includes(this.course.attributes.calendar.datesOff, id)
  }

  @action
  toggleIsOn() {
    this.courseCalendarEditor.toggleDefaultDate(
      this.course,
      this.rotationCalendar,
      this.rotation,
      this.semester.id,
      this.isOn
    )
  }

  @action
  prepareMove() {
    $(".js-add-day-card").css("opacity", 0)
  }
}
